<template>
  <div id="app" class="min-h-screen bg-gray-50 flex flex-col relative">
    <header class="flex-none self-center mb-8 p-8 tracking-widest border-b border-gray-300 text-green-800 text-center uppercase">Melon-Auth V2</header>
    <lang-selector class="absolute top-0 right-0 m-5" />
    <step-view />
    <app-footer />
  </div>
</template>

<script>
  import {provide, ref} from '@vue/composition-api'

  import LangSelector from '@/components/lang-selector.vue'
  import AppFooter from '@/components/app-footer.vue'
  import StepView from '@/views/steps/step-view.vue'

  export default {
    name: 'App',

    components: {
      LangSelector,
      AppFooter,
      StepView,
    },

    setup () {
      let config = ref(null)

      provide('$config', config)
      fetch('/config.json').then(async res => config.value = await res.json())
    },
  }
</script>

<style lang="scss" src="./assets/css/base.scss"></style>
